module.exports = "/_next/static/images/Hero@2x-07c869678aa345de745b979b986be97a.webp";